"use strict";
const badge = "_badge_14bvk_1";
const badgeIsSelected = "_badgeIsSelected_14bvk_26";
const badgeIsPressed = "_badgeIsPressed_14bvk_37";
const badgeIsDismissible = "_badgeIsDismissible_14bvk_43";
const badgeIsFocused = "_badgeIsFocused_14bvk_50";
const badgeText = "_badgeText_14bvk_55";
const styles = {
  badge,
  badgeIsSelected,
  badgeIsPressed,
  badgeIsDismissible,
  badgeIsFocused,
  badgeText
};
exports.styles = styles;
